import { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import { MainImage } from "../workDetailPage/WorkMainImage";
import Navigator from '../components/Navigation';
import { WorkFullImage } from "../workDetailPage/WorkFullImage";
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { ArticleMainImage } from "../articleDetailPage/ArticleMainImage";
import image1 from '../image/articles/article2_1.webp';
import image2 from '../image/articles/article2_2.webp';
import image3 from '../image/articles/article2_3.webp';
import image4 from '../image/articles/article2_4.webp';
import image5 from '../image/articles/article2_5.webp';
import image6 from '../image/articles/article2_6.webp';
import image7 from '../image/articles/article2_7.webp';
import image8 from '../image/articles/article2_8.webp';
import image9 from '../image/articles/article2_9.webp';
import image10 from '../image/articles/article2_10.webp';
import image11 from '../image/articles/article2_11.webp';
import image12 from '../image/articles/article2_12.webp';
import article1Thumbnail from '../image/articles/article1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Divider } from "@mui/material";
import { Wavedivider } from "../components/Wavedivider";
import { useMetaTags } from '../utils/useMetaTags';

function Article2(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ARTICLE2_PASSWORDS
      );
      const images1 = [image1]; // 1개 이미지
      const images2 = [image2, image3]; // 2개 이미지
      const images3 = [image9, image10]; // 3개 이미지
      const images4 = [image11, image12]; // 3개 이미지
      const images6 = [image4, image5, image6]; // 3개 이미지
      const images5 = [image7]; // 3개 이미지
      const images7 = [image8]; // 3개 이미지
      
      useMetaTags({
        title: '25.08. 회고 - Lynkim',
        description: '기회가 주어진다면 하고 싶은거 다 해보기  /  함께 살아가기  /  우리가 빛의 속도로 갈 수 없다면  /  건강하게 스트레스에서 회복하기',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'25.08. 회고'}
              titleEn={'25.08. Retrospective'}
              description={'기회가 주어진다면 하고 싶은거 다 해보기  /  함께 살아가기  /  우리가 빛의 속도로 갈 수 없다면  /  건강하게 스트레스에서 회복하기'}
              descriptionEn={'Trying everything I want if given the chance / Living alongside others / If We Cannot Travel at the Speed of Light / Recovering from stress in a healthy way'}
              category={'essay'}
              date={'2025.09.01.'}
              thumbnail={image1}/>
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection 
                title = '프롤로그' 
                subTitle = '깜짝 이벤트 열기'
                description=
                  {<div> 
                    회사에서 또 이벤트를 열었다. 일하는 곳이기는 하지만 많은 시간을 보내는 곳이기도 하니 이곳에서 나의 개인적인 욕망을 또 해소해보고 싶다는 생각이 든 것 같다. 
                   
                    삼행시 백일장을 열었는데, 생각보다 사람들의 글짓기 센스가 정말 대단하다는 것을 느꼈다. 
                    
                    개인적인 즐거움을 위해서도 있지만, 조금이나마 더 즐거운 분위기를 함께 느꼈으면 좋겠다는 생각으로 이벤트를 열고 있는데, 사람들이 정말로 조금이나마 부정적인 감정없이 함께 재미를 느꼈을까?
            </div>}
            />
            
            <ArticleImageLayout images={images2} />
            
            <ArticleTextSection 
                marginTop={true}
                subTitle = '베트남 호캉스'
                description=
                  {<div> 
                    갑자기 계획을 세워서 갑자기 일주일 뒤에 베트남으로 여행을 떠났다. 어디로 갈지도 그날 바로 정해서, 바로 비행기를 끊었다. 금요일부터 월요일까지 2박 4일로 일정을 잡았고, 첫 베트남 여행였지만, 베트남을 느끼기보다는 해외에서 호캉스를 즐기자는 컨셉으로 좋은 리조트에서 2박을 머무는 일정으로 예약했다. 
                    갑자기 정한 여행이고 계획을 꼼꼼히 세우지 않았는데, 그래서 그런지 훨씬더 즐겁고 재미있는 여행이 된 것 같다. 
                    <br/><br/>
                    3일동안 아침 수영 → 조식 뷔페 → 탁구 → 당구 → 점심 수영 → 점심 식사 → 오후 수영 → 당구 → 탁구 → 저녁 뷔페 → 밤 수영 → 반신욕을 반복했다. 

                    베트남에 있는 동안에는 현실의 어떠한 고민이나 생각 없이 “이 다음에는 뭘하면서 놀까?” 만을 생각하며 하루하루를 즐겁게 보냈다. 이번 여행이 너무나 만족스러워서 1년에 한번은 꼭 이렇게 해외에서 아무런 고민없이 하루하루만을 즐기는 시간을 만들어야 겠다는 생각을 했다.
                  </div>}
            />   

            <ArticleImageLayout images={images3} />
            <ArticleImageLayout images={images4} />
            
            <ArticleTextSection 
                marginTop={true}
                title = '[일] 기회가 주어진다면 하고 싶은거 다 해보기'
                description=
                  {<div>
                    블로그를 꾸미고 싶어서 취미로 프론트 개발을 하고 있는데, 회사에서도 코드 기여를 하고 싶다는 욕심을 이전 팀에 있을 때 부터 가지고 있었다. 디자이너가 간단한 기능 구현이나 퍼블리싱을 직접 한다면, 훨씬 더 효율적으로 협업할 수 있는 것이 아닐까? 하는 생각을 했는데, 디자이너가 괜히 코드를 건드리겠다고 하면 개발자 입장에서는 어떻게 받아들일지 전혀 감이 오지 않았고, 반대입장으로 생각해서 디자이너가 아닌 사람이 디자인을 건들고 싶다고 할 때 달갑지 않았기 때문에 쉽사리 하고 싶다는 말을 꺼내지 못했었다. 
                    <br/>
                    하지만 이번 7월 부터 구조적으로 안정된 팀이 아닌, 3명이 제품을 만드는 소규모의 팀에 오게되면서 각자의 역할 구분이 모호해졌고, 지나가는 말로 디자이너가 코드기여를 하는 것에 대해서 어떻게 생각하는지에 대해서 물어봤다. 

                    우리 팀의 개발자는 생각과는 다르게 긍정적으로 나의 그런 의향을 받아주셨고, 언제든지 할 수 있는 환경을 제공해주시겠다고 답변해주셨다.
                  </div>} 
                subDescription= {<div> 사실 긍정적인 태도를 갖고, 배려심을 갖고 있는 분이 우리팀의 엔지니어였기 때문에 나의 요구사항을 들어주셨을 수도 있을 것 같다. </div>} 
                marginBottom={true}
            />
            <ArticleTextSection 
                description=
                  {<div>
                    막상 개발을 하려고 하다보니, 작은 기여를 위해서도 생각보다 보안이나 개발환경을 세팅해야 하는 것이 많았고, 그것을 위해 다른 개발자의 시간을 뺐어서 도움을 받아야 하는 것이 너무 많았다. 

                    같은 팀의 개발자, 다른 팀의 개발자, 개발자 친구 등 많은 사람들이 관심을 갖고 개발 세팅 및 git 활용에 대해서 적극적으로 도움을 주셨다. 나의 욕심 때문에 귀찮게 만들어서 정말 죄송한 마음이 들었는데, 도움을 주시는 분들이 생각보다는 즐거워보였다. 역시 뉴비를 보는 고인물들은 은근한 희열을 느끼는 것 같다. 
                    <br/>
                    첫 PR을 남기면서 사실 생각보다도 더 큰 행복을 느꼈다. 회사에서 쉽게 얻지 못하는 새로운 역할을 해볼 수 있다는 것, 내가 전문성을 갖지 않은 분야에서도 무언가 해볼 수 있다는 자유가 굉장히 큰 행복으로 다가온 것 같다. 

                    그런 점에서 해볼 수 있는 기회를 주는 점, 못하는 것을 차근차근 기다려주고, 실수를 용인해준다는 것에 정말 큰 감사함을 느꼈다. 
                    <br/><br/>
                    <b>인생에서 경험하고 싶은 것이 있고, 기회를 얻고자 한다면, 거절당할 수 있음을 무릅쓰고 한번 말해보자.</b>
                  </div>} 
            />
            <ArticleImageLayout images={images5} />
            <ArticleTextSection 
                marginTop={true}
                title = '[삶] 함께 살아가기'
                description=
                  {<div>
                    문득 공허함을 느끼는 순간이 잦아졌다. 사람과 함께 있다가 헤어지고 나서, 갑자기 혼자가 되었을 때, 정확히는 옆에 도움을 줄 수 있는 사람이 있어야만 할 것 같은 불안함이 느껴진다. 

                    누군가에게 말을 해야만 할 것 같아서 할 말이 없는데도 이유없이 전화를 하는 빈도가 늘어났고, 전화를 하면서는 온전히 대화에 집중하지도 못하고 있다. 어떤 주제에 대해서 몰입해서 대화를 하고 싶은데도, 몰입해서 대화할 주제가 떠오르지 않는다. 

                    위태롭게 세워놓은 막대기처럼 한쪽으로 자꾸만 쓰러질 것 같은 느낌이다.
                    <br/><br/>
                    이렇게 불안감이 몰려올 때, 가끔 혼자서 2박 3일 정도 제주도나 가까운 일본으로 여행을 떠날 때가 있는데, 홀로서기를 연습하기를 하기 위해서 혼자 여행을 떠난다. 

                    혼자 여행을 가는건 항상 “혼자가 되어도 살아갈 수 있어. 누군가 나를 떠나도 괜찮아” 를 다짐하기 위해서다. 그런데 문득 혼자가 되기 위한 노력이 정말로 중요할지, 외로울 때 혼자가 될 힘을 기르기보다 어떻게 함께하는 순간을 잘 만들어갈 수 있을지를 고민하는게 좋지 않을까하는 생각이 들었다.
                    <br/><br/>
                    나는 함께 살아가는 사람으로서, 주위 사람들에게 어떤 사람이였을까? 나를 좋아해주고, 나와 함께 해주는 많은 사람들에게 나는 친구로써의 역할을 잘 해주고 있었을까? 

                    사실 친구라는 존재는 꼭 도움이 필요할 때 도움을 주는 존재라기보다 이유없이 삶에서 함께 살아가고 있음을 느끼게 해주는 존재가 되어야 하는게 아닐까?

                    사고를 당했다고 연락이 오거나, 좋은 일이 생겼다는 연락이 왔을 때, 소위 판을 깔아주면 친구로서의 역할을 잘 수행하고 있었지만, 아무일이 없었을 때 나는 주위 사람들에게 함께하고 있음을 항상 느끼게 해주는 존재였을까?
                    <br/><br/>
                    지금껏 돌이켜보면, 가끔 친구들이 인스타그램 DM으로 자주 재미있는 짤이나 영상을 보내주는데, 보지도 않고 늦게늦게 답변하거나 제대로 보지 않는 경우가 많았다. 

                    아무 이유없이 <b>그냥 너가 생각나서, 재미있는 것을 보여주고 싶어서</b>, 하는 행동들이 얼마나 나를 친구로 좋아해주고 있던 행동이였고, 삶에서 혼자가 아님을 느끼게 해주는 행동이였는지.
                  </div>} 
                marginBottom={true}
            />
            <ArticleImageLayout images={images6} />
            <ArticleTextSection 
                marginTop={true}
                description=
                  {<div>
                    나는 먼저 이유없이 재미있는 이야기를 하고 있을까? 내가 먼저 나의 소식을 시덥잖게 잘 이야기하고 있을까? 연락오기를 기다리지 않고 먼저 연락을 했을까? 귀찮다고 연락을 미루고 있지는 않았을까? 라는 반성을 하며, 내 주변 사람들이 외로움을 느끼지 않고, 항상 함께 살아가고 있다는 것을 잘 느끼게 해주는 사람이 되어야겠다는 생각을 했다. 
                  </div>} 
            />

            <ArticleTextSection 
                marginTop={true}
                title = '[독서] 우리가 빛의 속도로 갈 수 없다면'
                description=
                  {<div>
                    김초엽의 단편소설집 “우리가 빛의 속도로 갈 수 없다면”이라는 책을 추천 받아서 읽었다. 단편 하나하나가 기억에 남을 정도로 좋았는데, 그중 “우리가 빛의 속도로 갈 수 없다면”과 “감정의 물성”이 가장 인상에 남는 것 같다. 
                    <br/>
                  두 소설을 읽고나서 나에게 스스로 질문을 던지게 되었는데,
                  <br/><br/><b>
                  1. 절대 이루거나 도달하지 못함을 인지하더라도, 정말로 원하는 것이 있다면 할 것인가? <br/>
                  2. 우울함의 감정을 원할 때 느낄 수 있다면, 나는 우울한 감정 소유하려고 할 것인가?
                  </b><br/><br/>
                  나는 지금껏 이룰 수 없는 것이라는 부담감 때문에, 정말로 하고 싶은 것을 시작하거나, 제대로 끝까지 해보지 않은 것 같다. 나는 <a href="https://www.aladin.co.kr/shop/wproduct.aspx?ISBN=8982053318" target="_blank">“숨결이 바람이 될 때”</a>라는 책을 정말 좋아하는데, 인생에서 선택의 기로에 놓였다고 한다면 꼭 추천하는 책이다. 

                  내가 만약 앞으로의 70년 삶을 계획하고 살아가고 있었는데, 그 삶이 고작 1년 남았다고 한다면 어떻게 살 것인가? 

                  우리가 빛의 속도로 갈 수 없다면의 주인공도 꼭 가고 싶은 별에 도달하고 싶어서, 인간이 살아갈 수 있는 수명보다 더 멀리 떨어져있어 결국은 보지 못하고 죽을 것을 알면서도 기꺼이 별을 향해 출발하는 것처럼, 그렇게 중요하게 생각하는 삶의 가치에 집중해서 살아가야 하는게 아닐까?
                  <br/><br/>
                  감정의 물성에서의 사람들은 자신의 감정을 그저 소유하고 통제할 수 있음에 돈을 지불하고, 긍정적인 감정 뿐만 아니라 우울함이라는 부정적인 감정에 조차 돈을 지불하고 소유하고 통제하고자 했다. 만약 나에게 감정을 소유할 수 있는 기회가 있다면 구매할 것인가? 

                  가끔은 잘못된 방식으로 나의 감정을 다스릴 때가 있는 것 같다. 어떻게 보면 자해와 같은 행동이라고 생각한다. 

                  다른 사람에게 비난을 받고 싶어서 비난받을 행동을 일부러 하기도 한다. 생각해보면 그러지 않아도 된다는 위로가 필요했던 것 같다. 그건 잘못된 행동이야, 그렇게까지 하지 않아도 돼. 라는 말을 들으면서 상대방도 나와 같은 가치를 향유하고 있음을 느끼고 싶었던 것 같기도 하다. 

                  하지만 잘못된 방법으로 진심을 표현을 하거나, 그 마음을 직접 이야기하지 않으면 상대는 오해하고, 알아채지 못한다. 

                  감정을 다스리거나, 위로 받고 싶을 때, 더 현명하게 있는 그대로 드러낼 수 있을까?
                  </div>} 
            />

            <ArticleTextSection
                marginTop={true}
                title = '[삶] 건강하게 스트레스에서 회복하기' />
            <ArticleImageLayout images={images7} />
            <ArticleTextSection   
                marginTop={true}
                description=
                  {<div>
                    요즘 자주 해소할 수 없는 스트레스를 느낄 때가 많다. 그럴때 해소할 방법을 잘 알지 못해서, 의미없이 갑자기 몸에 좋지 않은 음식을 먹거나, 의미없는 영상을 보면서 시간을 버리거나, 아무것도 하지못하고 잠에 빠지기도 한다. 

                    그래서 아침 수영을 신청하면 루틴이 생기고, 활기가 생길 것 같아서 아침 수영을 신청했다. 원래는 오전 7시로 신청하려고 했는데 수강신청이 여간 어려운게 아니다. 다행히 오전 8시가 남아있어서 차질없이 수영을 시작할 수 있었고, 할 수 있다는 것 만으로 기분이 좋아졌다. 

                    잘못된 방식으로 스트레스를 해소하고 있음을 알고, 건강한 방법으로 감정을 다스려보자고 마음 먹은 것 만으로 스스로 잘 해나가고 있다고 생각한다. 
                    <br/><br/>
                    가끔 우울함에 빠지더라도, 다시 편안함을 느낄 수 있다는 걸 잊지말자.
                  </div>}
            />
           
          </div>    
          
          <NextItem to='/Article1' thumbnail={article1Thumbnail} nextProjectTitle='25년 7월 회고'/>

          <BackButton/>
          </ProtectedPage>
        </>
      )
  }
  
  export default Article2;
